import { ASSISTANT_PLAN_PROSE_CLASS } from "@/components/assistant/assistantPlanProse";
import type { WriteApprovalPlanItemCard as ItemCardModel } from "@/components/assistant/formatWriteApprovalSummary";
import { AssistantMarkdownContent } from "@/components/chat/AssistantMarkdownContent";
import { cn } from "@/lib/utils";

type Props = {
  item: ItemCardModel;
};

export function AssistantPlanItemCard({ item }: Props) {
  const { title, description, statusLabel = "Proposed" } = item;
  const body = description.trim();

  return (
    <article
      className={cn(
        "rounded-xl border border-[rgba(15,23,42,0.09)] bg-white/60 px-3 py-2.5 dark:border-white/10 dark:bg-white/[0.04]"
      )}
    >
      <div className="flex flex-wrap items-start justify-between gap-2">
        <h5 className="min-w-0 flex-1 text-sm font-semibold leading-snug text-[#101828] dark:text-white">
          {title}
        </h5>
        {statusLabel ? (
          <span className="shrink-0 rounded-full bg-[rgba(59,130,246,0.12)] px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-[#1d4ed8] dark:bg-blue-500/20 dark:text-blue-300">
            {statusLabel}
          </span>
        ) : null}
      </div>
      {body ? (
        <div className="mt-2 border-t border-[rgba(15,23,42,0.06)] pt-2 dark:border-white/10">
          <AssistantMarkdownContent content={body} className={ASSISTANT_PLAN_PROSE_CLASS} />
        </div>
      ) : null}
    </article>
  );
}
